<div class="sidebar">
  <div class="brand">
    <img src="/assets/images/LogoMark.png" alt="Logo" class="brand-logo" />
    <div class="brand-text">
      <span class="brand-title">Document Processing Engine</span>
      <span class="brand-subtitle">Knowledge Intelligence</span>
    </div>
  </div>

  <nav class="menu" aria-label="Main navigation">
    <span class="menu-label">Navigation</span>
    <div class="menu-scroll">
      <ng-container *ngFor="let item of menuItems">
        <a
          *ngIf="!item.submenuKey"
          [routerLink]="item.route"
          class="menu-item"
          [class.active]="isItemActive(item)"
        >
          <span class="menu-icon" [style.-webkit-mask-image]="'url(' + item.icon + ')'" [style.mask-image]="'url(' + item.icon + ')'" aria-hidden="true"></span>
          <span class="menu-label-text">{{ item.label }}</span>
        </a>

        <div class="menu-item-wrapper" *ngIf="item.submenuKey as submenuKey">
          <button
            type="button"
            class="menu-item menu-parent"
            [class.open]="isSubmenuOpen(submenuKey)"
            [class.current]="isSubmenuActive(submenuKey)"
            (click)="toggleSubmenu(submenuKey)"
          >
            <span class="menu-icon" [style.-webkit-mask-image]="'url(' + item.icon + ')'" [style.mask-image]="'url(' + item.icon + ')'" aria-hidden="true"></span>
            <span class="menu-label-text">{{ item.label }}</span>
            <span class="menu-chevron" [class.open]="isSubmenuOpen(submenuKey)">
              <span class="menu-chevron-icon" [style.-webkit-mask-image]="'url(' + chevronIcon + ')'" [style.mask-image]="'url(' + chevronIcon + ')'" aria-hidden="true"></span>
            </span>
          </button>

          <div class="submenu" *ngIf="isSubmenuOpen(submenuKey)">
            <a
              *ngFor="let sub of submenus[submenuKey]"
              [routerLink]="sub.route"
              class="submenu-item"
              [class.active]="!!sub.route && isActive(sub.route)"
            >{{ sub.label }}</a>
          </div>
        </div>
      </ng-container>
    </div>
  </nav>

  <div class="sidebar-footer">
    <a routerLink="/brain" class="brain-button" [class.active]="isActive('/brain')">
      <span class="brain-icon" [style.-webkit-mask-image]="'url(' + brainIcon + ')'" [style.mask-image]="'url(' + brainIcon + ')'" aria-hidden="true"></span>
      <span class="brain-label">Brain</span>
    </a>
  </div>
</div>
